import sessionStore from "./session-storage";
// Encode and decode functions from https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
function b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
    }));
}

function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

class LocalStorageLS {
    constructor() {
        this.set = function (a, b) {

            if (typeof (Storage) !== "undefined") {
                if(a != "_current_id"){
                    return localStorage.setItem(a, JSON.stringify(b));
                }
                else{
                    let tabs = JSON.parse(localStorage.getItem('_tabs'));
                    const now = new Date()
                    if(tabs){
                        if(!tabs.find(e => e.value === sessionStore.getUuid())){
                            tabs.push({value: sessionStore.getUuid(), active: false, expiry: now.getTime() + (5 * 60 * 1000)});
                            localStorage.setItem('_tabs',JSON.stringify(tabs));
                        }
                    }
                    else{
                        localStorage.setItem('_tabs',JSON.stringify([{value: sessionStore.getUuid(), active: false, expiry: now.getTime() + (5 * 60 * 1000)}]));
                    }
                    return this.setWithExpiry('_' + sessionStore.getUuid() + a, JSON.stringify(b), 5 * 60 * 1000);
                }
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.updateTabs = function (){
            if (typeof (Storage) !== "undefined") {
                let tabs = JSON.parse(localStorage.getItem('_tabs'));
                if(tabs && tabs.find(e => e.value === sessionStore.getUuid())){
                    let index = tabs.findIndex(e => e.value === sessionStore.getUuid());
                    const now = new Date()
                    tabs[index].expiry = now.getTime() + (5 * 60 * 1000);
                    tabs[index].active = false;
                    localStorage.setItem('_tabs',JSON.stringify(tabs));
                }
            }
            else {
                return 'NO STORAGE';
            }
        }
        this.activeTab = function (){
            if (typeof (Storage) !== "undefined") {
                let tabs = JSON.parse(localStorage.getItem('_tabs'));
                if(tabs && tabs.find(e => e.value === sessionStore.getUuid())){
                    let index = tabs.findIndex(e => e.value === sessionStore.getUuid());
                    tabs[index].active = true;
                    localStorage.setItem('_tabs',JSON.stringify(tabs));
                    if(localStorage.getItem('_' + tabs[index].value + '_current_id')){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                return false;
            }
            else {
                return 'NO STORAGE';
            }
        }
        this.getExpiryTabs = function (){
            if (typeof (Storage) !== "undefined") {
                let tabs = JSON.parse(localStorage.getItem('_tabs'));
                const now = new Date();
                if(tabs){
                    return tabs.filter(e => now.getTime() > e.expiry && !e.active);
                }
            }
            else {
                return 'NO STORAGE';
            }
        }
        this.get = function (a) {
            if (typeof (Storage) !== "undefined") {
                if(a != "_current_id"){
                    if(localStorage.getItem(a)){
                        return JSON.parse(localStorage.getItem(a));
                    }else{
                        return 'NO STORAGE';
                    }
                }
                else{
                    if(this.getWithExpiry('_' + sessionStore.getUuid() + a)){
                        return JSON.parse(this.getWithExpiry('_' + sessionStore.getUuid() + a));
                    }else{
                        return 'NO STORAGE';
                    }
                }
                
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.setE = function (a, b) {
            
            if (typeof (Storage) !== "undefined") {
                return localStorage.setItem(a, b64EncodeUnicode(JSON.stringify(b)));
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.getE = function (a) {
            if (typeof (Storage) !== "undefined") {
                return JSON.parse(b64DecodeUnicode(localStorage.getItem(a)));
            }
            else {
                return 'NO STORAGE';
            }
        };

        this.remove = function (a) {
            if (typeof (Storage) !== "undefined") {
                if(a != "_current_id"){
                    return localStorage.removeItem(a);
                }
                else{
                    let tabs = JSON.parse(localStorage.getItem('_tabs'));
                    if(tabs && tabs.find(e => e.value === sessionStore.getUuid())){
                        tabs = tabs.filter(item => item.value != sessionStore.getUuid());
                        localStorage.setItem('_tabs',JSON.stringify(tabs));
                    }
                    return localStorage.removeItem('_' + sessionStore.getUuid() + a);
                }
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.setWithExpiry = function (key, value, ttl) {
            const now = new Date()

            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire
            const item = {
                value: value,
                expiry: now.getTime() + ttl,
            }
            localStorage.setItem(key, JSON.stringify(item))
        }

        this.getWithExpiry = function (key) {
            const itemStr = localStorage.getItem(key)

            // if the item doesn't exist, return null
            if (!itemStr) {
                return null
            }

            const item = JSON.parse(itemStr)
            const now = new Date()

            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                // localStorage.removeItem(key)
                return null
            }
            return item.value
        }

        this.getWithExpiryRemove = function (key) {
            const itemStr = localStorage.getItem(key)

            // if the item doesn't exist, return null
            if (!itemStr) {
                return null
            }

            const item = JSON.parse(itemStr)
            const now = new Date()

            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem(key)
                return null
            }
            return item.value
        }
        return this;
    }
}
const LS = new LocalStorageLS();
export default LS;
